import { combineReducers } from 'redux';

import fileContents from "./file-reducer";
import graph from "./graph-reducer";

const cvtApp = combineReducers({
	fileContents,
	graph
});

export default cvtApp;


// WEBPACK FOOTER //
// ./src/redux/reducers.js